import { useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import ProtectedRoute from "./common/ProtectedRoute"; 
import Topbar from "./scenes/global/Topbar";
import Sidebar from "./scenes/global/Sidebar";

import UserAccounts from "./scenes/useraccounts";
import Subscriptions from "./scenes/subscriptions";

import Landing from "./pages/landing";
import Login from "./pages/login";
import Logout from "./pages/logout";
import Reset from "./pages/reset";
import Signup from "./pages/signup";
import ContactUs from "./pages/contactus";
import Subscribe from "./pages/subscribe";
import Pricing from "./pages/pricing";
import CheckoutSuccess from "./pages/subscribe/steps/checkoutsuccess";
import CheckoutCancelled from "./pages/subscribe/steps/checkoutcancel";
import CheckoutSuccessDodo from "./pages/subscribe/steps/checkoutsuccessdodo";
import CheckoutCancelledDodo from "./pages/subscribe/steps/checkoutcanceldodo";

import ConfirmMarketingOptIn from "./pages/confirmmarketingoptin";

import PaidMarketingLandingPage from "./pages/paidmarketinglandingpage";

import PaidMarketingLandingPageReddit from "./pages/paidmarketinglandingpagereddit";

import  OptOutOfMarketingEmails from "./pages/optoutmarketingemails";

import  OptOutOfPPCMarketingEmails from "./pages/optoutppcmarketingemails";

import  DemoPage from "./pages/demopage";

import TermsOfService from "./pages/termsofservice";

import Dashboard from "./scenes/dashboard";

import Unauthorized from "./scenes/unauthorized";

import NotFound from "./pages/pagenotfound";

import Users from "./scenes/users";
import Projects from "./scenes/projects";
import Requirements from "./scenes/requirements";
import VersionControl from "./scenes/versioncontrol";
import TestCases from "./scenes/testcases";
import TestCasesByPriority from "./scenes/testcases/indexByPriority";
import TestRuns from "./scenes/testruns";
import CodeReviews from "./scenes/codereviews";
import CodeReviewsByPriority from "./scenes/codereviews/indexByPriority";
import ApplicationLifecycleManagement from "./scenes/applicationlifecyclemanagement";
import UserStories from "./scenes/userstories";
import UserStoriesByPriority from "./scenes/userstories/indexByPriority";
import AgileBoards from "./scenes/agileboards";
import AgileProjectManagement from "./scenes/agileprojectmanagement";


import ToastMessageDisplay from "./common/ToastMessageDisplay"; 
import { UserProvider } from "./common/UserContext";
import { ApplicationModeProvider } from "./common/ApplicationModeContext";
import { UserCountProvider } from "./common/UserCountContext";
import { AccountProvider } from "./common/AccountContext";

import Bar from "./scenes/bar";
import Line from "./scenes/line";
import Pie from "./scenes/pie";
import Geography from "./scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import Calendar from "./scenes/calendar/calendar";
import { Navigate } from "react-router-dom";

function App() {
  const [theme, colorMode] = useMode();
  const [isSidebar, setIsSidebar] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");  // Add this line to hold the search term
  const location = useLocation();

  const publicPaths = ["/", 
    "/index.html", 
    "/login", 
    "/logout", 
    "/reset", 
    "/signup",
    "/contactus", 
    "/subscribe", 
    "/pricing", 
    "/terms-of-service", 
    "/confirm-marketing-opt-in",
    "/opt-out-of-marketing-emails",
    "/opt-out-of-ppc-marketing-emails",
    "/checkout-success", 
    "/checkout-cancelled",
    "/checkout-dodo-success", 
    "/checkout-dodo-cancelled",

    "/not-found",
    "/limited-time-discount-offer",
    "/demo",
    "/i-built-a-tool"];

  const isPublic = publicPaths.includes(location.pathname);

/************************************ PUBLIC PAGES ********************************************* */

if (isPublic) {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/index.html" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/logout" element={<Logout />} />
      <Route path="/reset" element={<Reset />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/contactus" element={<ContactUs />} />
      <Route path="/subscribe" element={<Subscribe />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terms-of-service" element={<TermsOfService />} />
      <Route path="/confirm-marketing-opt-in" element={<ConfirmMarketingOptIn />} />
      <Route path="/opt-out-of-marketing-emails" element={<OptOutOfMarketingEmails />} />
      <Route path="/opt-out-of-ppc-marketing-emails" element={<OptOutOfPPCMarketingEmails />} />
      <Route path="/limited-time-discount-offer" element={<PaidMarketingLandingPage />} />
      <Route path="/i-built-a-tool" element={<PaidMarketingLandingPageReddit />} />
      <Route path="/demo" element={<DemoPage />} />

      <Route path="/checkout-success" element={<CheckoutSuccess />} />
      <Route path="/checkout-cancelled" element={<CheckoutCancelled />} />
      <Route path="/checkout-dodo-success" element={<CheckoutSuccessDodo />} />
      <Route path="/checkout-dodo-cancelled" element={<CheckoutCancelledDodo />} />

      <Route path="/not-found" element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

/************************************ PRIVATE PAGES ********************************************* */

  return (
    <ApplicationModeProvider>  
      <UserProvider>
        <UserCountProvider>
          <AccountProvider>
            <ColorModeContext.Provider value={colorMode}>
              <ThemeProvider theme={theme}>
                <CssBaseline />
                <div className="app">
                  <Sidebar isSidebar={isSidebar} />
                  <main className="content">
                    <Topbar setIsSidebar={setIsSidebar} searchTerm={searchTerm} setSearchTerm={setSearchTerm}/>
                    <Routes>
                      <Route path="/app" element={<ProtectedRoute element={<Dashboard />} />} />

                      <Route path="/users" element={<ProtectedRoute element={<Users searchTerm={searchTerm} />} />} />
<Route path="/projects" element={<ProtectedRoute element={<Projects searchTerm={searchTerm} />} />} />
<Route path="/requirements" element={<ProtectedRoute element={<Requirements searchTerm={searchTerm} />} />} />
<Route path="/versioncontrol" element={<ProtectedRoute element={<VersionControl searchTerm={searchTerm} />} />} />
<Route path="/versioncontrol/list" element={<ProtectedRoute element={<VersionControl searchTerm={searchTerm} />} />} />
<Route path="/testcases" element={<ProtectedRoute element={<TestCases searchTerm={searchTerm} />} />} />
<Route path="/testcases/list" element={<ProtectedRoute element={<TestCases searchTerm={searchTerm} />} />} />
<Route path="/testcases/priority" element={<ProtectedRoute element={<TestCasesByPriority searchTerm={searchTerm} />} />} />
<Route path="/testruns" element={<ProtectedRoute element={<TestRuns searchTerm={searchTerm} />} />} />
<Route path="/testruns/list" element={<ProtectedRoute element={<TestRuns searchTerm={searchTerm} />} />} />
<Route path="/codereviews" element={<ProtectedRoute element={<CodeReviews searchTerm={searchTerm} />} />} />
<Route path="/codereviews/list" element={<ProtectedRoute element={<CodeReviews searchTerm={searchTerm} />} />} />
<Route path="/codereviews/priority" element={<ProtectedRoute element={<CodeReviewsByPriority searchTerm={searchTerm} />} />} />
<Route path="/applicationlifecyclemanagement" element={<ProtectedRoute element={<ApplicationLifecycleManagement searchTerm={searchTerm} />} />} />
<Route path="/applicationlifecyclemanagement/list" element={<ProtectedRoute element={<ApplicationLifecycleManagement searchTerm={searchTerm} />} />} />
<Route path="/userstories" element={<ProtectedRoute element={<UserStories searchTerm={searchTerm} />} />} />
<Route path="/userstories/list" element={<ProtectedRoute element={<UserStories searchTerm={searchTerm} />} />} />
<Route path="/userstories/priority" element={<ProtectedRoute element={<UserStoriesByPriority searchTerm={searchTerm} />} />} />
<Route path="/agileboards" element={<ProtectedRoute element={<AgileBoards searchTerm={searchTerm} />} />} />
<Route path="/agileboards/list" element={<ProtectedRoute element={<AgileBoards searchTerm={searchTerm} />} />} />
<Route path="/agileprojectmanagement" element={<ProtectedRoute element={<AgileProjectManagement searchTerm={searchTerm} />} />} />
<Route path="/agileprojectmanagement/list" element={<ProtectedRoute element={<AgileProjectManagement searchTerm={searchTerm} />} />} />


                      <Route path="/pie" element={<ProtectedRoute element={<Pie />} />} />
                      <Route path="/line" element={<ProtectedRoute element={<Line />} />} />
                      <Route path="/calendar" element={<ProtectedRoute element={<Calendar />} />} />
                      <Route path="/geography" element={<ProtectedRoute element={<Geography />} />} />

                      <Route path="/useraccounts" element={<ProtectedRoute element={<UserAccounts />} role="admin" />} />
                      <Route path="/subscriptions" element={<ProtectedRoute element={<Subscriptions />} role="admin" />} />

                      <Route path="/unauthorized" element={<ProtectedRoute element={<Unauthorized />} />} />

                      <Route path="*" element={<Navigate to="/not-found" replace />} />

                    </Routes>
                    <ToastMessageDisplay />
                  </main>
                </div>
              </ThemeProvider>
            </ColorModeContext.Provider>
            </AccountProvider>
        </UserCountProvider>
      </UserProvider>
    </ApplicationModeProvider>
  );
}

export default App;
